import { FC } from 'react';

import { Locale } from '../../../enums/Locale';
import { getLocaleAsString } from '../../../utils/localization';

import './Address.scss';

interface IAddressProps {
  name?: string;
  addressLine1: string;
  addressLine2?: string;
  addressLine3?: string;
  zipCode: string;
  city: string;
  stateCode?: string;
}

const Address: FC<IAddressProps> = ({
  addressLine1,
  addressLine2 = '',
  addressLine3 = '',
  zipCode,
  city,
  name,
  stateCode = '',
}) => {
  const locale = getLocaleAsString();

  if (locale === Locale.jaJP) {
    return (
      <address className="Address">
        <p>〒{zipCode}</p>
        <p>
          {stateCode}
          {city}
          {addressLine1}
          {addressLine2}
          {addressLine3}
        </p>
        <p>{name}</p>
      </address>
    );
  }

  if (locale === Locale.enJP) {
    return (
      <address className="Address">
        <p>{name}</p>
        <p>
          {city} {addressLine1} {addressLine2} {addressLine3}
        </p>
        <p>
          {stateCode} {zipCode}
        </p>
      </address>
    );
  }

  if (locale === Locale.enUS) {
    return (
      <address className="Address">
        <p>{name}</p>
        <p>{addressLine1}</p>
        {!!addressLine2 && <p>{addressLine2}</p>}
        {!!addressLine3 && <p>{addressLine3}</p>}
        <p>
          {city}, {stateCode} {zipCode}
        </p>
      </address>
    );
  }

  return (
    <address className="Address">
      <p>{name}</p>
      <p>{addressLine1}</p>
      {!!addressLine2 && <p>{addressLine2}</p>}
      {!!addressLine3 && <p>{addressLine3}</p>}
      <p>
        {zipCode} {city}
      </p>
    </address>
  );
};

export default Address;
